import React, { Component } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import debounce from 'lodash/debounce'

import SkeletonTile from '../../SkeletonTile/SkeletonTile'
import Search from '../../Search/Search'
import TextInput from '../../TextInput/TextInput'
import RenderOption from './RenderOption'

import {
  getSuggestionsLength,
  handleDataFetch,
  autoSuggest,
  updateCurrentQuery,
  getOperatorsByQueryType,
  canFieldHaveSearch,
  groupEntriesByCt,
  tableFilterKeyBindingHelper
} from '../util/helper'

import { grpHeadingTextArr } from '../util/constant'
import classNames from 'classnames'
import RenderTaxonomy from '../RenderFields/RenderTaxonomy'

const limitToFetch = 30

const SkeletonLoader = ({ size = 2 }) => {
  return (
    <div>
      {Array(size)
        .fill(1)
        .map((data, index) => {
          return (
            <div className="flex-v-center" key={index}>
              <SkeletonTile
                numberOfTiles={1}
                tileHeight={10}
                tileWidth={110}
                tileRadius={6}
                tileBottomSpace={12}
                tileTopSpace={12}
                tileleftSpace={18}
              />
            </div>
          )
        })}
    </div>
  )
}

class AutoComplete extends Component<any> {
  state = {
    queryType: this.props.queryType,
    suggestions: [],
    hasMore: true,
    skip: 0,
    count: 0,
    loading: false,
    suggestionsLength: 0,
    withOperator: true,
    inputValue: '',
    openAutoCompleteAtTop: false,
    isCursorInside: false
  }

  // isCursorInside: any = false

  async componentDidMount() {
    try {
      // console.log('this.props', this.props)
      this.controlAutoCompletePos()
      document.addEventListener('keyup', this.registerKeyBindings, false)
      document.addEventListener('click', this.handleClickOutside, false)
      this.setState({ loading: true })

      let ct_status = ''
      if (this.props.selectedModule === 'entries') {
        ct_status = this.props.queryObject.ct_status
      }
      const autoSuggestResponse = await autoSuggest({
        queryType: this.state.queryType,
        skip: 0,
        limit: limitToFetch,
        selectedModule: this.props.selectedModule,
        fetchData: this.props.fetchData,
        currentQuery: this.props.currentQuery,
        type: this.props.type,
        inputValue: this.state.inputValue,
        ct_status,
        isTaxonomyPlanEnabled: this.props.isTaxonomyPlanEnabled
      })
      const { withOperator, queryData, count } = autoSuggestResponse
      const length = getSuggestionsLength(queryData)

      this.setState({
        suggestions: queryData,
        withOperator,
        suggestionsLength: length,
        count,
        hasMore: length >= count ? false : true,
        skip: 0,
        loading: false
      })
      this.setState({ loading: false })
      this.disableScroll()
    } catch (error) {
      this.setState({ loading: false })
      console.log('AutoComplete ~ componentDidMount ~ error:', error)
    }
  }

  disableScroll = () => {
    const advQueryNode: HTMLDivElement = document.querySelector('.AdvancedQueryView__body-wrapper')
    if (advQueryNode && this.props.isAutoCompleteOpen) {
      advQueryNode.style.overflow = 'hidden'
    }
  }

  componentWillUnmount() {
    const advQueryNode: HTMLDivElement = document.querySelector('.AdvancedQueryView__body-wrapper')
    if (advQueryNode) {
      advQueryNode.style.overflow = 'auto'
    }
    document.removeEventListener('click', this.handleClickOutside, false)
    this.debounceSearch.cancel()
    document.removeEventListener('keyup', this.registerKeyBindings, false)
  }

  controlAutoCompletePos = () => {
    const autoCompleteHeight = 280
    if (this.props.modalPosData?.clientY) {
      let openDropdownAtTop =
        window.innerHeight - this.props.modalPosData?.clientY > autoCompleteHeight + 40 ? false : true
      this.setState({ openAutoCompleteAtTop: openDropdownAtTop })
      // console.log(' openDropdownAtTop:', openDropdownAtTop)
    }
  }

  registerKeyBindings = (event) => {
    if (this.props.isAutoCompleteOpen) {
      try {
        const options = {
          queryType: this.state.queryType,
          type: this.props.type,
        }

        const parentId = this.props.type === 'value' && this.state.queryType === 'taxonomyTermLabel' ? 'tableFilterScrollableDivtaxonomy-advanced-search' : 'autocompleteScrollableDiv'
        tableFilterKeyBindingHelper(event, parentId, options)
      } catch (err) {
        console.log(err)
      }
    }
  }

  handleClickOutside = (e) => {
    // const target = e.target
    if (!this.state.isCursorInside) {
      console.log('click outside detected')
      this.props.closeAutoComplete()
    }
  }

  handleSelectQuery = (queryType, selectedOpt) => {
    // const { operators } = this.state

    const { type, currentQuery, queryObject } = this.props
    const { key = [], operator = [], value = [] } = currentQuery
    const operators = getOperatorsByQueryType(queryType, key)
    let data = { queryType, selectedOpt, type, operators, currentQuery }
    let updatedCurrentQuery = updateCurrentQuery(data)

    //   let updatedTaxonomyQuery
    //   const isBlankTaxoQuery = updatedCurrentQuery?.queryType === 'taxonomyTermLabel' && (updatedCurrentQuery?.value[0]?.value === '_blank' || updatedCurrentQuery.value[0]?.uid === '_blank')
    //  if(isBlankTaxoQuery){
    //    updatedTaxonomyQuery = JSON.parse(JSON.stringify(updatedCurrentQuery))
    //   updatedTaxonomyQuery.value[0].value = updatedCurrentQuery.operator[0].value === '$in' ?  false : true
    //   updatedTaxonomyQuery.value[0].uid = '_blank'
    //   updatedTaxonomyQuery.operator[0].value = '$exists'
    //   console.log('updatedCurrentQuery after updatation:::', updatedTaxonomyQuery)
    //  }
    this.props.updateAdvancedQueryArray({
      // currentQuery: isBlankTaxoQuery ? updatedTaxonomyQuery : updatedCurrentQuery,
      currentQuery: updatedCurrentQuery,
      queryArray: this.props.queryArray,
      currentQueryIndex: this.props.currentQueryIndex,
      action: 'updateQueryArray',
      queryObject,
      parentQueryObject: this.props.parentQueryObject
    })

    this.props.closeAutoComplete()
  }

  fetchOnScroll = async () => {
    try {
      let { skip, suggestions, suggestionsLength, count, queryType } = this.state
      if (suggestionsLength >= count) {
        this.setState({ hasMore: false })
        return
      }

      let payload: any = {
        skip: skip + limitToFetch,
        limit: limitToFetch,
        queryType,
        // currentQuery: nextQuery,
        // selectedOption: this.props.selectedOption,
        inputValue: this.state.inputValue,
        fetchData: this.props.fetchData,
        suggestionsLength
      }

      if (queryType === 'referenceLabel') {
        const { key = [] } = this.props.currentQuery
        const valueOptions = (key[0] && key[0].valueOptions) || []
        let query = { _content_type_uid: { $in: valueOptions } }
        payload.query = query
      }

      const response: any = await handleDataFetch(payload)

      if (queryType === 'referenceLabel') {
        let entriesOptions = []
        suggestions.forEach((query) => {
          entriesOptions = [...entriesOptions, ...query.options]
        })

        entriesOptions = [...entriesOptions, ...response.data]
        const groupedEntries = groupEntriesByCt({ data: entriesOptions, count: response.count })
        suggestions = [...groupedEntries]
      } else {
        // console.log({ suggestions, queryType })
        const foundSuggestion = suggestions.find((obj) => obj.queryType === queryType)
        foundSuggestion.options = [...foundSuggestion.options, ...response.data]
      }

      const length = getSuggestionsLength(suggestions)

      this.setState({
        skip: skip + limitToFetch,
        count: response.count,
        suggestions: [...suggestions],
        suggestionsLength: length
      })

      //Added this condition just for tag
      if ((queryType === 'entriesTagLabel' || queryType === 'assetTagLabel') && (!response.data.length || !response.afterKey)) {
        this.setState({ hasMore: false })
      }
    } catch (error) {
      this.setState({ loading: false })
      console.log('fetchOnScroll  error', error)
    }
  }

  debounceSearch = debounce(async () => {
    try {
      this.setState({ loading: true })

      let ct_status = ''
      // let selectedKey = {}
      if (this.props.selectedModule === 'entries') {
        ct_status = this.props.queryObject.ct_status
      }

      const autoSuggestResponse = await autoSuggest({
        queryType: this.state.queryType,
        skip: 0,
        limit: limitToFetch,
        selectedModule: this.props.selectedModule,
        fetchData: this.props.fetchData,
        currentQuery: this.props.currentQuery,
        type: this.props.type,
        inputValue: this.state.inputValue,
        ct_status,
        isTaxonomyPlanEnabled: this.props.isTaxonomyPlanEnabled
      })

      const { withOperator, queryData, count, afterKey } = autoSuggestResponse
      const length = getSuggestionsLength(queryData)


      let hasMore = length >= count ? false : true;
      if (this.props.currentQuery.queryType === "entriesTagLabel" || this.props.currentQuery.queryType === "assetTagLabel") {
        hasMore = !afterKey ? false : true;
      }

      this.setState({
        suggestions: queryData,
        withOperator,
        suggestionsLength: length,
        count,
        hasMore: hasMore,
        skip: 0,
        loading: false
      })
    } catch (error) {
      this.setState({ loading: false })
      console.log('debounceInputChange error', error)
    }
  }, 300)

  handleInputChange = (value) => {
    this.setState({ inputValue: value })
    this.debounceSearch()
  }

  //This method is just for localized
  handleMultiSelectQuery = (selectedOpt, checked) => {
    // console.log('🚀 ~ file: Autocomplete.tsx:258 ~ AutoComplete ~ selectedOpt, checked:', selectedOpt, checked)
    const { currentQuery, queryObject } = this.props

    let currentQueryValue = currentQuery.value
    let value = (currentQueryValue[0] && currentQueryValue[0].value) || []

    if (value.find((v) => v.value === '$any') && selectedOpt.value !== '$any') {
      return
    }
    let updatedValue = []

    if (!currentQueryValue.length && checked) {
      updatedValue = [{ label: selectedOpt.label, value: [selectedOpt] }]
    }
    if (selectedOpt.value === '$any' && checked) {
      updatedValue = [{ label: 'Any Locales', value: [selectedOpt] }]
    } else if (checked) {
      let finalValue = [...value, selectedOpt]
      // const label = finalValue.map((singleVal) => singleVal.label).join(',')
      const label = finalValue.length === 1 ? finalValue[0].label : `${finalValue.length} Selected`
      updatedValue = [{ label, value: finalValue }]
    } else if (!checked) {
      let filteredValue = value.filter((v) => v.value !== selectedOpt.value)
      if (!filteredValue.length) {
        updatedValue = []
      } else {
        // const label = filteredValue.map((singleVal) => singleVal.label).join(',')
        const label = filteredValue.length === 1 ? filteredValue[0].label : `${filteredValue.length} Selected`
        updatedValue = [{ label, value: filteredValue }]
      }
    }

    const updatedCurrentQuery = { ...currentQuery, value: updatedValue }
    this.props.updateAdvancedQueryArray({
      currentQuery: updatedCurrentQuery,
      queryArray: this.props.queryArray,
      currentQueryIndex: this.props.currentQueryIndex,
      action: 'updateQueryArray',
      queryObject,
      parentQueryObject: this.props.parentQueryObject
    })
  }

  render() {
    const { suggestionsLength, suggestions, loading, inputValue, openAutoCompleteAtTop } = this.state
    const { type, queryType, currentQuery, withPortal } = this.props
    const { canSearch, searchPlaceholder } = canFieldHaveSearch(type, queryType, currentQuery)
    const isMulti = queryType === 'localizedInLabel' && type === 'value'

    const { width, clientX, clientY } = this.props.modalPosData || {}

    const styleObjWithPortal = openAutoCompleteAtTop
      ? { bottom: window.innerHeight - clientY, width, left: clientX + 1 }
      : { top: clientY + 42, left: clientX + 1, width }

    const styleObj = withPortal ? styleObjWithPortal : { top: '41px', left: '5px' }
    // console.log("🚀 ~ AutoComplete ~ render ~ styleObj:", styleObj)
    return (
      <div
        className={`AdvancedQueryView__suggestion-dropdown ${(this.props.type === 'value' && this.state.queryType === 'taxonomyTermLabel' && this.props.isTaxonomyPlanEnabled) ? 'AdvancedQueryView__suggestion-dropdown--taxonomy' : ''}`}
        onMouseEnter={() => {
          this.setState({ isCursorInside: true })
          // this.isCursorInside = true
        }}
        onMouseLeave={() => {
          this.setState({ isCursorInside: false })
          // this.isCursorInside = false
        }}
        style={styleObj}>
        {(canSearch && !(this.props.type === 'value' && this.state.queryType === 'taxonomyTermLabel')) && (
          <ul className="AdvancedQueryView__suggestion-items">
            <li
              className={classNames(
                'AdvancedQueryView__suggestion-item',
                'AdvancedQueryView__suggestion-item--search',
                type === 'value' && 'AdvancedQueryView__suggestion-item--borderValueField'
              )}>
              <Search
                testId="cs-advance-search-select-list-search"
                placeholder={searchPlaceholder}
                onChange={this.handleInputChange}
                value={inputValue}
                width="auto"
                onClear={true}
                type="secondary"
                version="v2"
                autoFocus
              />
            </li>
          </ul>
        )}
        {(this.props.type === 'value' && this.state.queryType === 'taxonomyTermLabel') ?
          <RenderTaxonomy
            type="value"
            filterObject={{
              value: [],
              placeHolder: 'Search taxonomies',
              autoFocus: false
            }}
            {...this.props}
            suggestions={suggestions}
            handleSelectQuery={this.handleSelectQuery}
          />
          :
          <ul className="AdvancedQueryView__suggestion-items" id="autocompleteScrollableDiv">
            <InfiniteScroll
              style={{ overflowY: 'hidden' }}
              dataLength={suggestionsLength}
              next={this.fetchOnScroll}
              hasMore={this.state.hasMore}
              loader={<SkeletonLoader />}
              scrollableTarget="autocompleteScrollableDiv"
              hasChildren={true}>
              {loading ? (
                <SkeletonLoader size={4} />
              ) : !suggestionsLength ? (
                <li className="AdvancedQueryView__no-result">No data available</li>
              ) : (
                suggestions.map((query, index) => {
                  return (
                    <div key={index}>
                      {query.group && (
                        <li
                          className={classNames(
                            'AdvancedQueryView__suggestion-item--heading',
                            grpHeadingTextArr.includes(query.group) &&
                            'AdvancedQueryView__suggestion-item--headingWithBorder'
                          )}
                          style={{ marginLeft: query.nestingLevel ? `${query.nestingLevel * 10}px` : '' }}>
                          {query.group}
                        </li>
                      )}
                      {query.options.map((opt, i) => {
                        return (
                          <RenderOption
                            key={index + i}
                            isMulti={isMulti}
                            currentQuery={currentQuery}
                            handleMultiSelectQuery={this.handleMultiSelectQuery}
                            opt={opt}
                            handleSelectQuery={this.handleSelectQuery}
                            query={query}
                          />
                        )
                      })}
                    </div>
                  )
                })
              )}
            </InfiniteScroll>
          </ul>}
      </div>
    )
  }
}

export default AutoComplete
